import React, { useEffect, useState, useCallback } from "react";
import queryString from "query-string";
import { useHistory } from 'react-router-dom';
import iconv from "iconv-lite";

import { makeStyles } from "@material-ui/core/styles";
import { Button, Typography } from "@material-ui/core";
import { Section } from "@components/organisms";

import { useTranslation } from "react-i18next";

//redux
import { useDispatch, useSelector } from "react-redux";

//redux functions
import { login, getToken } from "@store/user";
import { setSelectedCounty } from "@store/counties";

//network requests
import { AppConfigService } from "@services";

//App Settings
import { NetworkSettings, Config } from '@utils';

const useStyles = makeStyles((theme) => ({
  formContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: `calc(100vh - ${theme.mixins.toolbar["@media (min-width:600px)"].minHeight}px)`,
    maxWidth: 500,
    margin: `0 auto`,
  },
  section: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  label: {
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  disablePage: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minHeight: `calc(100vh - ${theme.mixins.toolbar["@media (min-width:600px)"].minHeight}px)`,
    maxWidth: "95%",
    margin: `0 auto`,
  },
  disablePageText: {
    fontWeight: 400,
    textShadow: "1px 2px #c0c0c0"
  },
}));

const LoginTest = (props) => {


  //Set Loading States variable
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    //on app load. check for latest version

    setLoading(true);

    AppConfigService.getLatestAppBuildDetails()
      .then((data) => {
        setLoading(false);

        let appDetails = JSON.parse(localStorage.getItem("appDetails"));

        if (appDetails === null) {
          localStorage.setItem("appDetails", JSON.stringify(data));
        } else {
          if (appDetails && appDetails.buildVersion !== data.buildVersion) {
            //save new app details and reload page
            window.location.reload();
            localStorage.setItem("appDetails", JSON.stringify(data));
          } else {
            //save new app details
            localStorage.setItem("appDetails", JSON.stringify(data));
          }
        }
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  //create history
  const history = useHistory();
  //redux
  const dispatch = useDispatch();
  const { user } = useSelector(state => state.user);

  //initial state
  const employeeRecordInitialState = {
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    openid_email: "",
    employer: "",
    employeeNumber: "",
    address: "",
    zipCode: "",
    city: "",
    state: "",
    dob: "",
  };

  //variables
  const [employeeRecord, setEmployeeRecord] = useState(employeeRecordInitialState);
  const [userAuthenticated, setUserAuthenticated] = useState(false);
  const [disableGMRConnectWeb, setDisableGMRConnectWeb] = useState(false);

  //updating complex variables
  const updateEmployeeRecordUser = useCallback((key, value) => {
    setEmployeeRecord((employeeRecord) => {
      return {
        ...employeeRecord,
        [key]: value,
      };
    });
  }, []);


  //on page load
  useEffect(() => {

    if (user !== null) {
      setEmployeeRecord(user);
      setUserAuthenticated(true);
    }

  }, []);

  useEffect(() => {
    if (userAuthenticated && employeeRecord?.employeeNumber?.length > 0) {
      // let buf = iconv.encode(`${Config.REACT_APP_USERNAME}:${Config.REACT_APP_PASSWORD}`, 'ascii'),
      const userInfo = `${Config.userName}:${Config.password}`;
      let generateToken = window.btoa(userInfo);

      dispatch(getToken(generateToken));
      dispatch(login(employeeRecord));
      history.replace("/dashboard");
    }
  }, [userAuthenticated]);


  useEffect(() => {
    const parsed = queryString.parse(props.location.search + props.location.hash);


    if (parsed && props.location.search.length > 0) {
      const doesExist = parsed.doesExist.toLowerCase() === "true";
      if (parsed.FirstName) {
        updateEmployeeRecordUser("firstName", parsed.FirstName);
      }
      if (parsed.Firstname) {
        updateEmployeeRecordUser("firstName", parsed.Firstname);
      }
      if (parsed.LastName) {
        updateEmployeeRecordUser("lastName", parsed.LastName);
      }
      if (parsed.Email) {
        const org = parsed.Email.split("@")[1];
        if (org === "emsc.root01.org" && !doesExist) {
          updateEmployeeRecordUser("openid_email", parsed.Email);
        } else {
          updateEmployeeRecordUser("email", parsed.Email);
        }
      }
      if (parsed.email) {
        const org = parsed.email.split("@")[1];
        if (org === "emsc.root01.org" && !doesExist) {
          updateEmployeeRecordUser("openid_email", parsed.email);
        } else {
          updateEmployeeRecordUser("email", parsed.email);
        }
      }
      if (parsed.ADcompany) {
        updateEmployeeRecordUser("employer", parsed.ADcompany);
      }
      if (parsed.EmployeeNumber) {
        updateEmployeeRecordUser("employeeNumber", parsed.EmployeeNumber);
      }
      if (parsed.PrimaryPhone && parsed.PrimaryPhone.length > 0) {
        updateEmployeeRecordUser(
          "phone",
          parsed.PrimaryPhone.replace(/[^\d]/g, "")
        );
      }
      if (parsed.ADBusinessUnit) {
        updateEmployeeRecordUser("businessUnit", parsed.ADBusinessUnit);
      }
      if (parsed.ADManagerEmail) {
        updateEmployeeRecordUser("managerEmail", parsed.ADManagerEmail);
      }
      if (parsed.ADPhysicalDeliveryOfficeName) {
        updateEmployeeRecordUser(
          "physicalDeliveryOfficeName",
          parsed.ADPhysicalDeliveryOfficeName
        );
      }
      if (parsed.Department) {
        updateEmployeeRecordUser("department", parsed.Department);
      }

      if (parsed.county && parsed.state) {
        updateEmployeeRecordUser("county", parsed.county);
        updateEmployeeRecordUser("state", parsed.state);
        dispatch(setSelectedCounty({ "county": parsed.county, "state": parsed.state }));
      }
      setUserAuthenticated(true);
    }
  }, [props]);



  const classes = useStyles();

  const loginOktaSaml = () => {
    let smallCallBaclUrl = window.location.origin + "/login";
    window.location.href =
      NetworkSettings.fullApiUrl +
      "saml/Login?returnUrl=" +
      smallCallBaclUrl;
  };

  return (
    <div>
      <Section className={classes.section}>
        {disableGMRConnectWeb ?
        <div className={classes.disablePage}>
          <Typography variant="h2" color="primary" className={classes.disablePageText}>We're still working on this page.</Typography>
          <Typography variant="h2" color="primary" className={classes.disablePageText}>We'll let you know as soon as it's ready.</Typography>
        </div> :
        <div className={classes.formContainer}>
          <Button
            size="large"
            variant="contained"
            color="primary"
            onClick={loginOktaSaml}
          >
            Continue With Okta
          </Button>
        </div>}
      </Section>
    </div>
  );
};

export default LoginTest;
